import React, { useEffect, useRef } from 'react';
import './App.css';
import cat from '../src/assets/cat.png'
import dog from '../src/assets/dog.png';
import fromicon from '../src/assets/form-icon.svg';
 

 
import logo from '../src/assets/logo_multicare.svg';
import { FaPhoneAlt } from 'react-icons/fa'; 
import { BsSignStopFill } from "react-icons/bs";
import { IoIosInformationCircle } from "react-icons/io";
import { TiArrowUpOutline } from "react-icons/ti";
import { FaMapMarkerAlt } from 'react-icons/fa';
import { FaIdCard } from 'react-icons/fa';  
import nameicon from '../src/assets/name.svg';
import phoneicon2 from '../src/assets/phone.svg';
import { IoPricetagsOutline } from "react-icons/io5";
import { useLocation } from 'react-router-dom';   
import { FaArrowRight, FaCheck } from 'react-icons/fa';

import zipicon from '../src/assets/zip.svg';
import nificon from '../src/assets/nif.svg';
import { MdEuroSymbol } from 'react-icons/md';  
import { FaUser } from 'react-icons/fa';  
import { FaEnvelope } from 'react-icons/fa';
import emailicon from '../src/assets/email.svg';
import arrowcta from '../src/assets/arrow-cta.svg';
import { useState } from 'react';
import Fidelidadepet from './Fidelidadepet';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import Footer from './Footer';
import CharmeSlider from './CharmeSlider';


import { lightGreen } from '@mui/material/colors';
import { FaCheckCircle, FaUserMd,  FaPercentage } from 'react-icons/fa';  
import PageNotFound from './PageNotFound'; // Componente 404


function App() {
  const [isSubmitting, setIsSubmitting] = useState(false); // Adicionar este estado
  const [countdown, setCountdown] = useState(15); 
  const targetUrl = 'https://www.multicare.pt/PT/particulares/Paginas/default.aspx'; // URL de destino

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  const [DivShowNameEmail, setDivShowNameEmail] = useState(0);


const nomeinp = useRef();
const emailinp = useRef();
const nifinp = useRef();
const zipinp = useRef();
const mobileinp = useRef();
  const [formstep, setFromstep] = useState(1);
 
  let sessionValue = sessionStorage.getItem('user_session');
  let sessionValueGuid = sessionStorage.getItem('user_sessionGuid');
  const getUUID = () => {
    if (crypto && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    } else {
      // Simple UUID generator (not cryptographically secure)
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    }
  };
  // Verifica e define `user_session`
  if (!sessionValue) {
    sessionValue = `session_${new Date().getTime()}`;  
    sessionStorage.setItem('user_session', sessionValue);  
  }

 
  useEffect(() => {
    // Extrair parâmetros da URL
    const queryParams = new URLSearchParams(window.location.search);
  
    // Obter os valores das query strings e converter para minúsculas
    let nameFromEmail = queryParams.get("NameFromEmail")?.toLowerCase() || "";
    let emailFromEmail = queryParams.get("emailFromEmail")?.toLowerCase() || "";
  
   
    // Definir valores padrão se for "name" ou "email"
    nameFromEmail = nameFromEmail === "name" ? "" : nameFromEmail;
    emailFromEmail = emailFromEmail === "email" ? "" : emailFromEmail;
 
    // Se existir `NameFromEmail`, atualiza o campo de nome
    if (nameFromEmail && nomeinp && nomeinp.current) {
      setFormdata((prevState) => ({ ...prevState, name: nameFromEmail }));
      nomeinp.current.value = nameFromEmail;  // Define valor no input de nome
    }
    if (!checkemailload(emailFromEmail)) {
      console.log("E-mail inválido.");
      return;
    }
  
  

  
    // Se existir `emailFromEmail` e ele for válido, atualiza o campo de e-mail
    if (emailFromEmail && emailinp && emailinp.current) {
      setFormdata((prevState) => ({ ...prevState, email: emailFromEmail }));
      emailinp.current.value = emailFromEmail;  // Define valor no input de e-mail
    }
  
    // Se ambos os campos estão preenchidos e válidos, avança para o passo 2
    if (nameFromEmail && emailFromEmail && nomeinp && nomeinp.current) {
      setFromstep(2);  // Define o próximo passo apenas se ambos os valores existirem
      document.getElementById('Txt2Step').innerHTML =
        nomeinp.current.value.split(" ")[0] + ", já está no último passo para solicitar a sua simulação.";
        setDivShowNameEmail(1);
        sendDataToGoogleSheet({
          fromwhere: "step1" ,
          name: nomeinp.current.value,
          email: emailinp.current.value,
        });
    }
  }, []);  
  
 
  
const [formdata, setFormdata] = useState(
  {
    pettype:'',
    agerange:'',
    petage:'',
    name:'',
email:'',
nif:'',
zip:'',
phone:''
  }
);

const marks = [
  
];
function valuetext(value) {
   return `${value}`;
}
const handleSliderChange = (event, newValue) => {
  let oldData={...formdata}
 
  setFormdata(oldData);
};

 
const [showMoreText, setShowMoreText] = useState(false);  

 

const validateform = (e) =>{
  let oldData={...formdata}
  let inp = e.target.name;
  let inpvalue =  e.target.value.slice(0, e.target.maxLength);
  if (inp === "nif" && inpvalue.length === 9) {
    zipinp.current.focus();
  }
 

  oldData[inp] =inpvalue;
    setFormdata(oldData);
}



const validatezip = (e) => {
  let value = e.target.value.replace(/ /g, "");  
  let inputNumbersOnly = value.replace(/\D/g, "");
  if (inputNumbersOnly.length > 8) {
    inputNumbersOnly = inputNumbersOnly.substr(0, 8);
  }
  const splits = inputNumbersOnly.match(/.{1,4}/g);
   let spacedNumber = "";
  if (splits) {
    spacedNumber = splits.join("-");
  }
  let oldData={...formdata}
  let inp = e.target.name;
  oldData[inp] =spacedNumber;
  if (value.length == 8) {
    mobileinp.current.focus();
  }
    setFormdata(oldData);
};
useEffect(()=>{

 
});
useEffect(() => {
  window.addEventListener('load', handleLoad, { once: true });

  return () => window.removeEventListener('load', handleLoad);
}, []);

const handleLoad = () => {
  sendDataToGoogleSheet({ fromwhere: "load" });
};

const checkempty = (inp) =>{
  if(inp.current.value == '')
    {
      inp.current.style.backgroundColor = "white"
      inp.current.classList.add("shadowinput");
      inp.current.focus();
      return false;
    }else{
      inp.current.classList.remove("shadowinput");
    return true;
    }
}

const checknumberonly = (inp) =>{
  if(!isNaN(inp.current.value))
    {
      inp.current.style.backgroundColor = "white"
      inp.current.classList.add("shadowinput");
      inp.current.focus();
      return false;
    }else{
      inp.current.classList.remove("shadowinput");
    return true;
    }
}



const checkemailload = (email) => {
  var emailregex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  return emailregex.test(email);
};


const checkemail = (inp) =>{
  const errorMessage = document.getElementById('emaillbl'); 
  var emailregex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  if(!emailregex.test(inp.current.value))
    {
      errorMessage.textContent = 'Introduza um endereço de e-mail válido.'; 

      inp.current.style.backgroundColor = "white"
      inp.current.classList.add("shadowinput");
      inp.current.focus();
      return false;
    }else{
      errorMessage.textContent = ''; 
      inp.current.classList.remove("shadowinput");
    return true;
    }
}

const checkmobile = (inp, length) => {
  const errorMessage = document.getElementById('mobilelbl');
  let value = inp.current.value;
  value = value.replace(/\D/g, ''); // Remove non-digit characters
  let iserror = false;

  // Check if the number is 9 digits long and starts with allowed prefixes
  if (value.length === 9 && value[0] === '9' && ['1', '2', '3', '6'].includes(value[1])) {
    iserror = false;
    errorMessage.textContent = '';
  } else if (value.length === 9 && (value[0] !== '9' || !['1', '2', '3', '6'].includes(value[1]))) {
    errorMessage.textContent = '91, 92, 93 ou 96.';
    iserror = true;
  } else if (value.length < 9) {
    errorMessage.textContent = '9 dígitos.';
    iserror = true;
  }

  if (iserror) {
    inp.current.style.backgroundColor = "white";
    inp.current.classList.add("shadowinput");
    inp.current.focus();
    return false;
  } else {
    inp.current.classList.remove("shadowinput");
    return true;
  }
};


const checkpostalcode = (inp, length) =>{
  const errorMessage = document.getElementById("ziplbl");
  let iserror = false;
  if(inp.current.value.length != length)
    {
      errorMessage.textContent = 'O código postal deve ser exactamente 7 dígitos.';
      iserror = true;
    }else{
      iserror = false;
      errorMessage.textContent = '';
    }

  if(iserror)
    {
      inp.current.style.backgroundColor = "white"
      inp.current.classList.add("shadowinput");
      inp.current.focus();
      return false;
    }else{
      inp.current.classList.remove("shadowinput");
    return true;
    }
}


const checknif = (inp, length) => {
  const errorMessage = document.getElementById("niflbl");
  let iserror = false;
  const nif = inp.current.value;

  // Verifica o comprimento do NIF
  if (nif.length != length) {
    errorMessage.textContent = 'O NIF deve ter exatamente 9 dígitos.';
    iserror = true;
  } else if (!validateNIF(nif)) {
    // Se o comprimento está correto, valida o NIF com as regras adicionais
    errorMessage.textContent = 'O NIF fornecido é inválido.';
    iserror = true;
  } else {
    iserror = false;
    errorMessage.textContent = '';
  }

  if (iserror) {
    inp.current.style.backgroundColor = "white";
    inp.current.classList.add("shadowinput");
    inp.current.focus();
    return false;
  } else {
    inp.current.classList.remove("shadowinput");
    return true;
  }
}

// Função auxiliar para validar o NIF (integrada dentro do checknif)
function validateNIF(nif) {
  // Verifica se o primeiro ou os dois primeiros dígitos são válidos
  if (
    !['1', '2', '3', '5', '6', '8'].includes(nif.substr(0, 1)) &&
    !['45', '70', '71', '72', '77', '79', '90', '91', '98', '99'].includes(nif.substr(0, 2))
  ) {
    return false;
  }

  // Cálculo do total com base nos primeiros 8 dígitos
  let total =
    nif[0] * 9 +
    nif[1] * 8 +
    nif[2] * 7 +
    nif[3] * 6 +
    nif[4] * 5 +
    nif[5] * 4 +
    nif[6] * 3 +
    nif[7] * 2;

  // Calcula o módulo 11
  let modulo11 = total - parseInt(total / 11) * 11;
  let comparador = modulo11 == 1 || modulo11 == 0 ? 0 : 11 - modulo11;

  // Verifica se o último dígito corresponde ao comparador
  return nif[8] == comparador;
}


const submitform = (step) => {

  if (!checkempty(nomeinp) ) {
    setFromstep(1)
    return;
  }
 
 
  if (!checkemail(emailinp) ) {
    setFromstep(1)
    return;
  }
 
  if (step == 1) {
    sendDataToGoogleSheet({
      fromwhere: "step1" ,
      name: nomeinp.current.value,
      email: emailinp.current.value,
    });
    setFromstep(2)
  }
  

  document.getElementById('Txt2Step').innerHTML = 
  nomeinp.current.value.split(" ")[0] + ", já está no último passo para solicitar a sua simulação.";


 
  
  if(formstep == 2){
if(
 checknif(nifinp, 9) == true
  && checkpostalcode(zipinp, 8) == true
  && checkmobile(mobileinp,9) == true
)
 {
  sendDataToGoogleSheet({
    fromwhere : "step3",
    name: nomeinp.current.value,
    email: emailinp.current.value,
    phone: mobileinp.current.value,
    vat: nifinp.current.value,
    postalCode: zipinp.current.value
  }); 

  senddata();

  const timer = setInterval(() => {
    setCountdown((prevCountdown) => {
      if (prevCountdown === 1) {
        window.location.href = targetUrl; // Redireciona após a contagem regressiva
        clearInterval(timer); // Para o timer após o redirecionamento
      }
      return prevCountdown - 1;
    });
  }, 1000);
  
     

}

  }
}




const senddata = async  () => {

  if (isSubmitting) return; // Bloqueia se já estiver enviando dados


  let sessionValueGuid = sessionStorage.getItem('user_sessionGuid');
  
  // Se a variável for nula ou indefinida, gere um novo GUID
  if (!sessionValueGuid) {
    sessionValueGuid = getUUID(); // Gera um novo GUID
    sessionStorage.setItem('user_sessionGuid', sessionValueGuid); // Salva no sessionStorage
  }

  // Se o nome for "Affiliate", dispara a lógica específica
  if (formdata.name.trim().toLowerCase() === "affiliate" || formdata.name.trim().toLowerCase().includes("test")) {
    setFromstep(3);
    const img = document.createElement("img");
    img.src = `https://emas.uinterbox.com/tracking/cnv?org=5634&evt=11103&cid=${sessionValueGuid }`;
    img.height = "1";
    img.width = "1";
    img.style.display = "none"; // Opcional: esconde a imagem
    document.body.appendChild(img);
    return;
  }


  const data = {
  nif: formdata.nif,
  name: formdata.name,
  email: formdata.email,
  phone: formdata.phone,
  zip: formdata.zip,
  argan: "",
  petname:"",
  licenseplate: "",
  observations: "",
  source: 439,
  scheduletype: 0,
  isClient: true,
  family: 0,
  uuid: sessionValueGuid,
  birthdate: "",
  date: new Date().toISOString()
  }
  const response = await fetch(
    //'https://localhost:7261/Leads/add', 
    'https://fidelidadeapi.quickflowai.com/Leads/add',
    {
    method: 'POST',
    body: JSON.stringify(data),  
    headers: {
      'Content-Type': 'application/json'
    }
  });
  const result = await response.json();
 

// Se a variável for nula ou indefinida, gere um novo GUID
if (!sessionValueGuid) {
  sessionValueGuid = getUUID(); // Gera um novo GUID
  sessionStorage.setItem('user_sessionGuid', sessionValueGuid); // Salva no sessionStorage
}

 
   if(response.status == 200){
    setIsSubmitting(true);
    console.log("start");

    
    if (result.value == "Duplicate lead"){
      setFromstep(5)
    }else{
      const today = new Date();
      const day = today.getDay();
      if (day >= 1 && day <= 4){
        setFromstep(3)
        const img = document.createElement("img");
        img.src = `https://emas.uinterbox.com/tracking/cnv?org=5634&evt=11103&cid=${sessionValueGuid }`;
        img.height = "1";
        img.width = "1";
        img.style.display = "none"; // Opcional: esconde a imagem
        document.body.appendChild(img);

      }else{
        setFromstep(4)
        const img = document.createElement("img");
        img.src = `https://emas.uinterbox.com/tracking/cnv?org=5634&evt=11103&cid=${sessionValueGuid }`;
        img.height = "1";
        img.width = "1";
        img.style.display = "none"; // Opcional: esconde a imagem
        document.body.appendChild(img);
        
      }
    }

     }
}





function getSaudacao() {
  const now = new Date();
  const hour = now.getHours();

  if (hour >= 6 && hour < 13) {
    return "Bom dia";
  } else if (hour >= 13 && hour < 20) {
    return "Boa tarde";
  } else {
    return "Boa noite";
  }}


  
  const sendDataToGoogleSheet = async ({
    fromwhere ="",
    name = "",
    email = "",
    phone = "",
    vat = "",
    postalCode = "",
    observations = "N/A",
    petname= "N/A",
    petage = "N/A",
    publisher = "N/A"
  } = {}) => {
    // URL do Google Apps Script com CORS Anywhere como proxy
    const scriptUrl = 'https://script.google.com/macros/s/AKfycbzn-Mbyx3RixBni7507Zpsibl1dqJHC21Dlu9tPDg_TS0lk8p-q11gyvSPsqx4rIzfH/exec';
    const proxyUrl = 'https://corsproxy.io/?';

    

  
  
    let sessionValue = sessionStorage.getItem('user_session');
    let sessionValueGuid = sessionStorage.getItem('user_sessionGuid');
    
    // Verifica e define `user_session`
    if (!sessionValue) {
      sessionValue = `session_${new Date().getTime()}`;  
      sessionStorage.setItem('user_session', sessionValue);  
    }
    
    // Verifica e define `user_sessionGuid` (GUID)
    if (!sessionValueGuid) {
      sessionValueGuid = getUUID(); // Gera um GUID único
      sessionStorage.setItem('user_sessionGuid', sessionValueGuid); // Armazena o GUID no sessionStorage
    }
  
 
    const getGeoLocation = async () => {
      try {
        const response = await fetch('https://ipinfo.io/json');
    
        if (!response.ok) {
          throw new Error('Failed to fetch IP information');
        }
    
        const result = await response.json();
    
        // Use the correct field names returned by ipinfo.io
        if (result && result.country && result.region && result.city) {
          return `${result.country}, ${result.region}, ${result.city}`;
        } else {
          return 'Localização não encontrada';
        }
      } catch (error) {
        console.error('Erro ao obter geolocalização:', error);
        return 'Localização não encontrada';
      }
    };
    
  
    
    const getIPAddress = async () => {
      try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        return data.ip; // Retorna o IP público
      } catch (error) {
        console.error('Erro ao obter o IP:', error);
        return 'IP Não Disponível';  
      }
    };

    const geoIp = await getGeoLocation();
    const userIP = await getIPAddress();

    // Definir valores padrão internos
    const data = {
      Campaign: 'Multicare',
      Session: sessionValue, 
      Date: new Date().toISOString(),  
      IP: userIP || 'N/A', 
      Device: navigator.userAgent.includes('Mobile') ? 'Mobile' : 'Desktop',  
      Geo_IP: geoIp,  
      Name: name, 
      Email: email,  
      Phone: phone,  
      Vat: vat,  
      PostalCode: postalCode,  
      Observations: observations,
      PetName:petname, 
      PetAge:petage, 
      Publisher: publisher ,
      UUID: sessionValueGuid 
    };
  
    try {
     
      const response = await fetch(proxyUrl + scriptUrl, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
  
      const result = await response.text();
      console.log(`Sucess ${result}`);
    } catch (error) {
      console.error(`Error ${error}`);
    }
  };
  

  
  const saudacao = getSaudacao();
  return (
    

    
    <>
 


<div className="w-full bg-[#F0F1F3] py-4 px-3 lg:py-8 lg:px-5 flex items-center justify-between lg:justify-center top-0 left-0 z-50">
  <img
    src={logo}
    alt="Logo"
    className="my-2 mx-auto max-w-[160px] md:max-w-[200px] lg:max-w-[240px] lg:absolute lg:left-1/2 lg:transform lg:-translate-x-1/2"
  />
</div>




 <div className="w-full flex flex-col lg:flex-row ">
 
<div className="hidden lg:flex w-full flex-col bg-[rgb(239,171,0)] lg:bg-[url('../src/assets/Multicare_MO_saude_mulher.png')] bg-no-repeat bg-cover bg-center pt-4 lg:pt-12 text-white relative h-[600px]">

  {/* Bola no canto superior direito */}
  <div className="absolute top-[20px] right-[20px] bg-[#FFA800] rounded-full w-[150px] h-[150px] flex flex-col justify-center items-center text-white text-center p-[20px]">
    <span className="text-sm font-semibold leading-tight">DESDE</span>
    <span className="text-2xl font-bold leading-tight">7,5€/MÊS</span>
    <span className="text-xs font-semibold leading-tight">POR PESSOA</span>
  </div>
   <div className="absolute bottom-[100px] right-[80px] text-left w-[300px]">
    <p className="text-[#FFA800] text-2xl font-semibold mb-2">ESTOMATOLOGIA <br></br>E MEDICINA DENTÁRIA</p>
    <p className="text-white text-1xl font-bold leading-snug">
      UM SORRISO<br />
      SAUDÁVEL<br />
      MUDA TUDO.
    </p>
  </div>


</div>
<div className="flex lg:hidden w-full flex-col bg-[rgb(239,171,0)] bg-[url('../src/assets/Multicare_MO_saude_mulher.png')] bg-no-repeat bg-cover bg-center pt-4 text-white relative h-[300px]">

  {/* Overlay apenas nos últimos 150px com gradiente progressivo */}
  <div className="absolute bottom-0 left-0 w-full h-[150px] bg-gradient-to-t from-[#EFAB00] to-[#EFAB0000]"></div>

  {/* Bola superior */}
  <div className="absolute top-[20px] right-[20px] bg-[#FFA800] rounded-full w-[150px] h-[150px] flex flex-col justify-center items-center text-white text-center p-[20px] z-10">
    <span className="text-sm font-semibold leading-tight">DESDE</span>
    <span className="text-2xl font-bold leading-tight">7,5€/MÊS</span>
    <span className="text-xs font-semibold leading-tight">POR PESSOA</span>
  </div>

  {/* Texto inferior */}
  <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 text-center z-10">
    <p className="text-lg font-semibold leading-tight">ESTOMATOLOGIA</p>
    <p className="text-lg font-semibold leading-tight">E MEDICINA DENTÁRIA</p>
  </div>

</div>






<div className='w-full bg-[#EFAB00] pt-[20px] pb-5 lg:px-16 lg:pb-10 ' id="askproposal">





 






      <div className={`shadow-2xl bg-white rounded-xl mx-4 pt-2 px-4 lg:px-12 mb-3 lg:h-[500px] ${formstep > 2 ? 'hidden' : 'block'}`}>

  <div className={` ${formstep == 1 ? 'block' :'hidden'}`}>
  <p className='font-bebasneuepro font-semibold text-center py-2 uppercase lg:mb-2' style={{ fontSize: '24px' }}>

    
    
  {saudacao}, preencha os dados para pedir a sua simulação<br></br>Seguro de Saúde Dental </p>

  <div className='px-5 relative mb-3'>
 <input type='text' ref={nomeinp} name="name" value={formdata.name} onChange={validateform}  className={`block w-full py-4 pl-12 pr-8   rounded-lg border-2 border-[#eaeaea] focus:border-[#ffc0cb] outline-none font-bold placeholder:font-normal `} placeholder='O seu nome é?'   maxLength={100} /> 
 <span className='absolute top-[1px] left-16 pl-1   text-[0.7em]  transition-all duration-10 text-themered' ></span>
 <FaUser className='absolute top-[50%] -translate-y-[50%] left-9 text-black w-[20px] h-[20px]' />
  

 </div>

 <div className='px-5 relative mb-3'>
 <input type='text' ref={emailinp} name="email" value={formdata.email} onChange={validateform}  className={`block w-full py-4 pl-12 pr-8   rounded-lg border-2 border-[#eaeaea] focus:border-[#ffc0cb] outline-none font-bold placeholder:font-normal `} placeholder='Email'   maxLength={100} /> 
 <span id="emaillbl" className='absolute top-[1px] left-16 pl-1   text-[0.7em]  transition-all duration-10 text-themered' ></span>
 <FaEnvelope className='absolute top-[50%] -translate-y-[50%] left-9 text-black w-[20px] h-[20px]' />
  
 </div>
 <div className="pl-5 py-3.5">


 <p className='text-xs lg:text-md text-[#212121]'>
  <strong
    onClick={() => setShowMoreText(!showMoreText)} // Toggle on click
    style={{ cursor: 'pointer' }} // Pointer style
  >
    Ver termos e Condições
  </strong>
  <br />
  {/* Conditionally render additional text */}
  {showMoreText && (
    <div>
      <span>
        Os dados pessoais por si acima facultados serão tratados <strong>para posterior contacto telefónico com a finalidade de realizar a simulação</strong> e para fazer o acompanhamento comercial da mesma, com fundamento no desenvolvimento de diligências pré-contratuais a pedido do titular e no interesse legítimo do desenvolvimento da atividade comercial da Fidelidade.
      </span>
      <p className='text-themered text-xs leading-1 py-4'>
        <a
          href='https://www.fidelidade.pt/PT/protecao-dados/Documents/Politica_de_Privacidade_e_Protecao_de_Dados_Pessoais%E2%80%93FIDELIDADE.pdf'
          className='underline text-themered'
          target='_blank'
          rel='noopener'
          
        >
          Consulte aqui, informação mais detalhada sobre proteção e tratamento dos seus dados pela Fidelidade.
        </a>
      </p>
      <br />
    </div>
  )}
</p>


  </div>
   </div>
  
 <div className={` ${formstep === 2 ? 'block' :'hidden'}`}>
 <p className='font-bebasneuepro font-semibold text-center py-2 uppercase lg:mb-2' style={{ fontSize: '24px' }} id="Txt2Step">Preencha o formulário</p>

 
 
{DivShowNameEmail === 1 && (

  <>
    <div className='px-5 relative mb-3'>
      <input 
        type='text' 
        ref={nomeinp} 
        name="name" 
        value={formdata.name} 
        onChange={validateform}  
        className={`block w-full py-4 pl-12 pr-8 rounded-lg border-2 border-[#eaeaea] focus:border-[#ffc0cb] outline-none font-bold placeholder:font-normal`} 
        placeholder='O seu nome é?' 
        maxLength={100} 
      /> 
      <span className='absolute top-[1px] left-16 pl-1 text-[0.7em] transition-all duration-10 text-themered'></span>
      <FaUser className='absolute top-[50%] -translate-y-[50%] left-9 text-black w-[20px] h-[20px]' />
    </div>

    <div className='px-5 relative mb-3'>
      <input 
        type='text' 
        ref={emailinp} 
        name="email" 
        value={formdata.email} 
        onChange={validateform}  
        className={`block w-full py-4 pl-12 pr-8 rounded-lg border-2 border-[#eaeaea] focus:border-[#ffc0cb] outline-none font-bold placeholder:font-normal`} 
        placeholder='Email' 
        maxLength={100} 
      /> 
      <span id="emaillbl" className='absolute top-[1px] left-16 pl-1 text-[0.7em] transition-all duration-10 text-themered'></span>
      <FaEnvelope className='absolute top-[50%] -translate-y-[50%] left-9 text-black w-[20px] h-[20px]' />
    </div>
  </>
)}

 <div className='px-5 relative mb-3'>
 <input type='number' inputmode="numeric"  ref={nifinp} name="nif" value={formdata.nif} onChange={validateform}  className={`block w-full py-4 pl-12 pr-8   rounded-lg border-2 border-[#eaeaea] focus:border-[#ffc0cb] outline-none font-bold placeholder:font-normal `} placeholder='NIF'  maxLength={9} /> 
 <span id="niflbl" className='absolute top-[1px] left-16 pl-1   text-[0.7em]  transition-all duration-10 text-themered' ></span>
 <FaIdCard  className='absolute top-[50%] -translate-y-[50%] left-9 text-black w-[20px] h-[20px]' />
  
 </div>

<div className='flex flex-col lg:flex-row mb-1'>
<div className='w-full px-5 relative mb-3'>
 <input type='text' inputmode="numeric"  ref={zipinp} name="zip" value={formdata.zip} onChange={validatezip}  className={`block w-full py-4 pl-12 pr-8   rounded-lg border-2 border-[#eaeaea] focus:border-[#ffc0cb] outline-none font-bold placeholder:font-normal `} placeholder='Código Postal'   maxLength={8} /> 
 <span id="ziplbl" className='absolute top-[1px] left-16 pl-1   text-[0.7em]  transition-all duration-10 text-themered' ></span>
 <FaMapMarkerAlt   className='absolute top-[50%] -translate-y-[50%] left-9 text-black w-[20px] h-[20px]' />
  
 </div>

 <div className='w-full px-5 relative mb-3'>
 <input type='number' inputmode="numeric"  name="phone" ref={mobileinp} value={formdata.phone} onChange={validateform}  className={`block w-full py-4 pl-12 pr-8   rounded-lg border-2 border-[#eaeaea] focus:border-[#ffc0cb] outline-none font-bold placeholder:font-normal `} placeholder='Nº Telemóvel'   maxLength={9} /> 
 <span id="mobilelbl" className='absolute top-[1px] left-16 pl-1   text-[0.7em]  transition-all duration-10 text-themered' ></span>
 <FaPhoneAlt className='absolute top-[50%] -translate-y-[50%] left-9 text-black w-[20px] h-[20px]' />
  
 </div>

  </div>

 </div>


 


 <div className="relative w-full flex justify-center items-center">
  {/* Back Button (Left-Aligned, Absolute Position) */}
  <button
    onClick={() => setFromstep(1)}
    className={`absolute left-0 bg-gray-300 hover:bg-gray-400 rounded-full w-[40px] h-[40px] flex justify-center items-center ${
      formstep === 1 ? 'invisible' : 'visible'
    }`}
    style={{ marginLeft: '20px' }}  // Optional: Add margin if needed
  >
    <img src={arrowcta} alt="Back Arrow" className="w-[10px] rotate-180" />
  </button>

 
 
<button
  onClick={() => {
    if (formstep === 1) {
      submitform(1);
    } else if (formstep === 2) {
      submitform(2);
    }
  }}
  className={`flex items-center justify-center w-[230px] ${
    formstep === 1 ? 'bg-[#28a745] hover:bg-[#86ad5e]' : 'bg-[#FF5722] hover:bg-[#FF7043]'
  } text-center rounded-md p-2.5 text-white font-bebasneuepro font-semibold text-lg lg:text-2xl focus:outline-none focus:ring-4 ${
    formstep === 1 ? 'focus:ring-[#86ad5e]' : 'focus:ring-[#FF7043]'
  } shadow-lg transition-all duration-200`}
  
  
  role="button"
  aria-label={formstep === 1 ? 'Ir para o próximo passo' : 'Solicitar simulação'}
>
  {/* Conditionally render different icons for each step */}
  {formstep === 1 ? (
    <>
      <FaArrowRight className="mr-2" /> {/* Icon for Step 1 */}
      PRÓXIMO PASSO
    </>
  ) : (
    <>
      <FaCheck className="mr-2" /> {/* Icon for Step 2 (Pedir Simulação) */}
      PEDIR SIMULAÇÃO
    </>
  )}
</button>

</div>


 

 
  {formstep < 3 && (
    <div className="flex justify-center pt-5">

<div className="w-[300px] lg:w-[500px] h-8 bg-gray-300 rounded-full mt-2 mb-[30px]">

    <div
      className="h-full bg-[#28a745] rounded-full transition-all duration-300"
      style={{ width: formstep === 1 ? '30%' : formstep === 2 ? '70%' : '0%' }}
    ></div>
  </div>
</div>

  )}

 


</div>

 

<div className={`max-w-[90%] lg:max-w-[95%] ${formstep == 3? 'block' : 'hidden'} text-white text-left font-bebasneuepro text-2xl lg:text-3xl p-[30px]`}><p className={`text-white text-left font-bebasneuepro text-2xl lg:text-2xl mb-3 font-semibold mt-10 lg:mt-5 lg:mb-5 `}>
Olá  {formdata["name"]}!</p>
Obrigado pelo seu pedido de simulação.<br />
Em breve, a nossa equipa entrará em contacto consigo para lhe apresentar a nossa melhor proposta.<br />
Enquanto isso, pode explorar mais sobre os nossos produtos e serviços no nosso site:  <br></br>
<a href='https://www.multicare.pt/PT/particulares/Paginas/default.aspx' target='_blank' className="text-black font-bold">www.multicare.pt</a><br />
Obrigado<br /> <br></br>
<strong>Fidelidade</strong>
</div>
<div className={`max-w-[90%] lg:max-w-[95%] ${formstep == 4 ? 'block' : 'hidden'} text-white text-left font-bebasneuepro text-2xl lg:text-3xl p-[30px]`}>
<p className={`text-white text-left  font-bebasneuepro text-2xl lg:text-2xl mb-3 font-semibold mt-10 lg:mt-5 lg:mb-5 `}>

  Olá  {formdata["name"]}!</p>
Obrigado pelo seu pedido de simulação.<br />
Em breve, a nossa equipa entrará em contacto consigo para lhe apresentar a nossa melhor proposta.<br />
Enquanto isso, pode explorar mais sobre os nossos produtos e serviços no nosso site:  <br></br>
<a href='https://www.multicare.pt/PT/particulares/Paginas/default.aspx' target='_blank' className="text-black font-bold">www.multicare.pt</a><br />
Obrigado<br /> <br></br>
<strong>Fidelidade</strong>
 
</div>

<div className={`max-w-[90%] lg:max-w-[95%] ${formstep == 5 ? 'block' : 'hidden'} text-white text-left font-bebasneuepro text-2xl lg:text-3xl p-[30px]`}>
<p className={`text-white text-left  font-bebasneuepro text-2xl lg:text-2xl mb-3 font-semibold mt-10 lg:mt-5 lg:mb-5 `}>
Obrigado  {formdata["name"]}!</p>
Verificamos que já tinha pedido um contacto anteriormente.<br />
A nossa equipa entrará em contacto consigo o mais breve possível para ajudar a esclarecer.<br />
Enquanto isso, pode explorar mais sobre os nossos produtos e serviços no nosso site:  <br></br>
<a href='https://www.multicare.pt/PT/particulares/Paginas/default.aspx' target='_blank' className="text-black font-bold">www.multicare.pt</a><br />
Obrigado<br /> <br></br>
<strong>Fidelidade</strong>
</div>



      </div>


      
    </div>

 
 
 <div className="w-full bg-[#F0F1F3] py-10 px-5">
  <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8 items-start">

    {/* Título */}
    <div>
      <div className="flex items-center mb-4">
        <FaCheck className="text-[#FFA800] text-2xl mr-2" />
        <h3 className="text-2xl font-bold text-[#333]">3 RAZÕES</h3>
      </div>
      <p className="text-[#333] text-lg font-medium">Para fazer um seguro Multicare Dental</p>
    </div>

    {/* Simples */}
    <div>
      <div className="flex items-center mb-4">
        <FaCheck className="text-[#FFA800] text-2xl mr-2" />
        <h4 className="text-xl font-bold text-[#333]">SIMPLES</h4>
      </div>
      <p className="text-[#333]">Sem períodos de carência, sem franquias e sem preexistências.</p>
    </div>

    {/* Prevenção */}
    <div>
      <div className="flex items-center mb-4">
        <FaCheck className="text-[#FFA800] text-2xl mr-2" />
        <h4 className="text-xl font-bold text-[#333]">PREVENÇÃO</h4>
      </div>
      <p className="text-[#333]">Atos médicos incluídos, sem valores a cargo da pessoa segura. Produto que aposta na prevenção da saúde oral, com atos médicos incluídos para esse efeito.</p>
    </div>

    {/* Qualidade */}
    <div>
      <div className="flex items-center mb-4">
        <FaCheck className="text-[#FFA800] text-2xl mr-2" />
        <h4 className="text-xl font-bold text-[#333]">QUALIDADE</h4>
      </div>
      <p className="text-[#333]">Rede Multicare Dental constituída por clínicas selecionadas com critérios exigentes no que toca a padrões de qualidade, inovação tecnológica e proximidade.</p>
    </div>

  </div>
</div>


 
    <CharmeSlider/>


 
    <Footer />
    </>
   
  );
}

export default App;